import { baseService } from "./base";

class VistarService {
  getAllVistarAccounts() {
    return baseService.get("/api/vistar-accounts");
  }

  getVistarAccountNetworks() {
    return baseService.get(`/api/vistar-account/networks`);
  }

  getVistarVenues(networkId) {
    return baseService.get(`/api/network/${networkId}/vistar-venues`);
  }
}

const vistarService = new VistarService();

export { vistarService, VistarService };
